import client from '../../../apollo/client';

import {
  FeatureFlagDocument,
  FeatureFlagQuery,
  FeatureFlagQueryVariables,
  useFeatureFlagQuery
} from './FeatureFlag.queries.generated';

export async function getFeatureFlagStatus(name: string) {
  try {
    const {data} = await client.query<FeatureFlagQuery, FeatureFlagQueryVariables>({
      query: FeatureFlagDocument,
      variables: {name}
    });
    return data?.featureFlag?.enabled || false;
  } catch (e) {
    return false;
  }
}

export const useIsFeatureFlagEnabled = (name: string) => {
  const {data, loading} = useFeatureFlagQuery({
    variables: {name}
  });

  return {
    isFeatureEnabled: data?.featureFlag?.enabled || false,
    isLoading: loading
  };
};

// a way to clear the cache. To clear all, call without args.
// to clear a specific flag, call with the name of the flag.
export const clearFeatureFlagCache = (name?: string) => {
  if (name) {
    client.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'featureFlag',
      args: {name}
    });
  } else {
    client.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'featureFlag'
    });
  }
};
